export default __webpack_public_path__ + "static/media/elevator-music.7d46359b.png";